import { render, staticRenderFns } from "./gradeHistory.vue?vue&type=template&id=9163dc7c&scoped=true"
import script from "./gradeHistory.vue?vue&type=script&lang=js"
export * from "./gradeHistory.vue?vue&type=script&lang=js"
import style0 from "./gradeHistory.vue?vue&type=style&index=0&id=9163dc7c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9163dc7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9163dc7c')) {
      api.createRecord('9163dc7c', component.options)
    } else {
      api.reload('9163dc7c', component.options)
    }
    module.hot.accept("./gradeHistory.vue?vue&type=template&id=9163dc7c&scoped=true", function () {
      api.rerender('9163dc7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/log/gradeHistory.vue"
export default component.exports